<template>
	<div class="grid-content">
		<div class="grid-content-title">
			<div class="name">计费设置</div>
		</div>
		<div v-if="loading" style="min-height: 20rem;" v-loading="loading"></div>
		<template v-else>
			<div class="grid-content-operate">
				<el-button @click="addCharging" size="small">
					<i class="el-icon-circle-plus"></i>
					<span>添加计费</span>
				</el-button>
				<el-button type="primary" size="small" @click="submitCharging" :loading="charging.loading">保存设置
				</el-button>
			</div>
			<div class="grid-content-content charging">
				<template v-if="charging.rule.length>0">
					<div class="weather">
						<div class="a">特殊天气开关</div>
						<div class="b">
							<el-switch active-color="#13ce66" v-model.number="charging.weather" :active-value="1" :inactive-value="0">
							</el-switch>
						</div>
						<div class="tips">
							根据运营区域的真实天气情况开启或关闭，<span style="color: red;">虚假上报天气查实扣除信誉分-0.5分</span>
						</div>
					</div>
					<el-form label-width="120px" size="medium">
						<div v-for="(charging,index) in charging.rule" class="rule">
							<div class="bt">
								<div class="left">
									<span class="el-icon-time" :style="{'margin-right':'0.3rem'}"></span>
									<span style="color: red">{{charging.timeout?charging.timeout:'起始时间未选'}}</span>
									<span style="padding: 0 0.375rem;">-</span>
									<span>计费时间段{{index+1}}</span>
									<span v-if="charging.add"
										style="color: #008000;margin-left: 0.625rem;">(新增，保存后生效)</span>
								</div>
								<div class="right">
									<el-popconfirm title="确定删除此计费时段吗？" @confirm="delCharging(index)">
										<i class="el-icon-close" slot="reference"></i>
									</el-popconfirm>
								</div>
							</div>
							<div class="box">
								<el-form-item label="起始时间">
									<div style="display: inline-block;">
										<el-time-picker size="medium" v-model="charging.timeout" value-format="HH:mm"
											format="HH:mm" placeholder="选择时间" />
									</div>
								</el-form-item>
								<el-form-item label="起步设置">
									<div style="display: inline-block;width: 8rem;">
										<el-input-number style="width: 100%;" v-model.number="charging.jichu_km"
											controls-position="right" :min="1" :max="50" :precision="3">
										</el-input-number>
									</div>
									<div style="display: inline-block;padding: 0 0.5rem;">公里内，收费</div>
									<div style="display: inline-block;width: 8rem;">
										<el-input-number style="width: 100%;" v-model.number="charging.jichu_price"
											controls-position="right" :min="1" :max="100" :precision="2">
										</el-input-number>
									</div>
									<div style="display: inline-block;padding: 0 0.5rem;">元，每超出1公里加收
									</div>
									<div style="display: inline-block;width: 8rem;">
										<el-input-number style="width: 100%;" v-model.number="charging.chao_price"
											controls-position="right" :min="0" :max="100" :precision="2">
										</el-input-number>
									</div>
									<div style="display: inline-block;padding: 0 0.5rem;">元</div>
								</el-form-item>
								<el-form-item label="等待设置">
									<div style="display: inline-block;width: 8rem;">
										<el-input-number style="width: 100%;" v-model.number="charging.await_time"
											controls-position="right" :min="0" :precision="0">
										</el-input-number>
									</div>
									<div style="display: inline-block;padding: 0 0.5rem;">
										分钟内免费等待，超时每1分钟加收
									</div>
									<div style="display: inline-block;width: 8rem;">
										<el-input-number style="width: 100%;" v-model.number="charging.await_full"
											controls-position="right" :min="0" :precision="2">
										</el-input-number>
									</div>
									<div style="display: inline-block;padding: 0 0.5rem;">元</div>
								</el-form-item>
								<el-form-item label="返程设置">
									<div style="display: inline-block;padding-right: 0.5rem;">
										超出区域或公里数按总里程加收返程费</div>
									<div style="display: inline-block;width: 8rem;">
										<el-input-number style="width: 100%;" v-model.number="charging.return_percent"
											controls-position="right" :min="0" :max="100" :precision="0">
										</el-input-number>
									</div>
									<div style="display: inline-block;padding: 0 0.5rem;">%</div>
									<div
										style="display: inline-block;padding-left: 0.5rem;color: red;font-size: 0.75rem;">
										(需在“区域设置”配置后，则此值生效)</div>
								</el-form-item>
								<el-form-item label="特殊天气设置">
									<div style="display: inline-block;padding-right: 0.5rem;">
										雷、雨、雪等恶劣天气加价
									</div>
									<div style="display: inline-block;width: 8rem;">
										<el-input-number style="width: 100%;" v-model.number="charging.weather_price"
											controls-position="right" :min="0" :precision="2">
										</el-input-number>
									</div>
									<div style="display: inline-block;padding: 0 0.5rem;">元，总里程费用加价
									</div>
									<div style="display: inline-block;width: 8rem;">
										<el-input-number style="width: 100%;" v-model.number="charging.weather_percent"
											controls-position="right" :min="0" :max="100" :precision="0">
										</el-input-number>
									</div>
									<div style="display: inline-block;padding: 0 0.5rem;">%</div>
									<div
										style="display: inline-block;padding-left: 0.5rem;color: red;font-size: 0.75rem;">
										(特殊天气开关若开启，则此值生效)</div>
								</el-form-item>
							</div>
						</div>
					</el-form>
				</template>
				<el-empty v-if="!loading && charging.rule.length<=0" style="height: 20rem;" description="暂无计费规则"
					:image-size="100">
				</el-empty>
			</div>
		</template>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: true,
				charging: {
					loading: false,
					weather: 0,
					rule: []
				}
			};
		},
		created() {
			this.postCharging();
		},
		methods: {
			addCharging() {
				const that = this;
				var toDate = new Date();
				var toH = (toDate.getHours() < 10) ? "0" + toDate.getHours() : toDate.getHours();
				var toM = (toDate.getMinutes() < 10) ? "0" + toDate.getMinutes() : toDate.getMinutes();
				that.charging.rule.unshift({
					'timeout': toH + ":" + toM,
					'jichu_km': '0',
					'jichu_price': '0',
					'chao_price': '0',
					'return_percent': '0',
					'await_time': '0',
					'await_full': '0',
					'weather_price': '0',
					'weather_percent': '0',
					'add': true
				});
			},
			delCharging(index) {
				const that = this;
				if (that.charging.rule.length > 1) {
					that.charging.rule.splice(index, 1);
				} else {
					that.charging.rule = [];
				}
			},
			submitCharging() {
				const that = this;
				if (that.charging.rule.length <= 0) {
					that.$message.error("至少要有一个计费时间段");
					return;
				}
				try {
					that.charging.rule.forEach((rule, index) => {
						if (rule['timeout'] == null) {
							throw new Error((index + 1));
						}
					});
				} catch (e) {
					that.$message.error("【计费时间段" + e.message + "】的起始时间未选择");
					return;
				}
				that.charging.loading = true;
				that.$post('operateCharging', {
					mode: "save",
					weather: that.charging.weather,
					rule: that.charging.rule
				}).then(res => {
					that.charging.loading = false;
					that.$message.success("保存成功");
				}).catch(e => {
					that.charging.loading = false;
					that.$alert((e != undefined && e.message != undefined && e.message) ? e.message :
						"未知错误，请重试", '提示', {
							type: 'error',
							confirmButtonText: '确定'
						});
				});
			},
			postCharging() {
				const that = this;
				that.loading = true;
				that.$post('operateCharging').then(res => {
					setTimeout(function() {
						that.loading = false;
						that.charging.weather = res.data.weather;
						that.charging.rule = res.data.charging_rule;
					}, 500);
				}).catch(e => {
					that.loading = false;
					that.$alert((e != undefined && e.message != undefined && e.message) ? e.message :
						"未知错误，请重试", '提示', {
							type: 'error',
							confirmButtonText: '确定'
						});
				});
			}
		}
	}
</script>

<style scoped>
	.charging .rule {
		position: relative;
		width: 90%;
		min-height: 20rem;
		margin-bottom: 1.25rem;
		border-radius: 0.625rem;
		background-color: #eff8fb;
	}

	.charging .rule .bt {
		position: absolute;
		display: flex;
		align-items: center;
		width: 100%;
		color: black;
		font-size: 0.875rem;
		padding: 0.9375rem 1.25rem;
		box-sizing: border-box;
	}

	.charging .rule .bt .left {
		flex: 1;
		font-weight: bold;
	}

	.charging .rule .bt .right {
		color: #99a9bf;
		font-size: 1.25rem;
		cursor: pointer;
	}

	.charging .rule .box {
		padding: 4rem 1.25rem 0.5rem 1.25rem;
		box-sizing: border-box;
	}

	.config>>>.el-form-item__label,
	.charging>>>.el-form-item__label {
		color: #99a9bf;
	}

	.charging .weather {
		display: flex;
		height: 2.4rem;
		align-items: center;
	}

	.charging .weather {
		padding-bottom: 1.25rem;
	}

	.charging .weather .a {
		color: #99a9bf;
		font-size: 0.875rem;
		margin-right: 1rem;
	}

	.charging .weather .b {
		margin-right: 1.25rem;
	}

	.charging .weather .tips {
		color: #999999;
		font-size: 0.75rem;
	}
</style>
